let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("57lIX")).then(() => parcelRequire('8AbUu'));